/* eslint-disable no-console */
import { useDeleteObjectOption, useMapExternalCodes } from "@app/store/service/connectorService"
import { appStore, defaultOrderStore } from "@app/store/store"
import { ADRESS_TYPES, IframeMessages, ORDER_LINE_TYPES, OrderErrors, SCANCODE_TYPES, TICKET_TYPES } from "@app/utils/constants"
import { selectMissingCapacity, selectNeededCapacity, selectUsedCapacity, selectVisitorCount } from "@app/utils/selectors"
import tracking from "@app/utils/tracking"
import { uuidv4 } from "@tecreation/funnel-components"
import { ResponseError, useSelector } from "@tecreation/js-state-react"
import { useRaiseError } from "./errorActions"

/**
 * @param {OrderErrors} error
 */
export const addOrderError = error => {
	appStore.set(state => {
		let errors = [...state.errors]
		errors.push({
			id: uuidv4(),
			message: error,
		})
		return {
			order: {
				...state.order,
				errors,
			},
		}
	})
}

export const resetOrderState = () => {
	appStore.set(state => {
		return {
			order: {
				...defaultOrderStore,
				priceActions: appStore.get("core.kioskMode") || appStore.get("core.employeeMode") || appStore.get("core.onSiteMode") ? [] : state.order.priceActions,
				shoppingCart: appStore.get("core.kioskMode") || appStore.get("core.employeeMode") || appStore.get("core.onSiteMode") ? [] : state.order.shoppingCart,
			},
		}
	})
}

export const calcPrice = () => {
	appStore.set(rootState => {
		let state = rootState.order

		let relation = rootState.core.relation

		let productPrice = 0
		productPrice += Object.keys(state.products).reduce((p, key) => {
			return p + state.products[key].cnt * state.products[key].article.price
		}, 0)

		let loungerPrice = 0
		loungerPrice += state.loungers.reduce((p, lounger) => {
			return p + lounger.price
		}, 0)

		let visitorKindPrice = 0
		visitorKindPrice += Object.keys(state.visitorKinds).reduce((p, key) => {
			let cnt = state.visitorKinds[key].cnt
			if (relation && relation.tags && relation.tags.find(e => e.tag === "Handicap")) {
				if (cnt >= 2) {
					cnt -= 1
				}
			}
			return p + cnt * state.visitorKinds[key].visitor.minPrice
		}, 0)

		return {
			order: {
				...state,
				productPrice,
				loungerPrice,
				visitorKindPrice,
			},
		}
	})
}

export const removeProducts = () => {
	appStore.set(state => ({
		...state,
		order: {
			...state.order,
			products: {},
		},
	}))
	calcPrice()
}

export const addKioskVoucher = voucher => {
	appStore.set(rootState => {
		let state = rootState.order
		const article = voucher?.details
			? {
					...voucher.details[0],
					price: voucher.details[0].unitPrice,
				}
			: voucher
		const products = { ...state.products }
		const price = article.price || article.unitPrice
		const key = article.voucherId + ";" + price
		const line = {
			article,
			cnt: products[key] ? products[key].cnt + 1 : 1,
		}
		products[key] = line

		return {
			order: {
				...state,
				products,
			},
		}
	})
}

export const removeKioskVoucher = product => {
	appStore.set(rootState => {
		let state = rootState.order

		const article = product?.details
			? {
					...product.details[0],
					price: product.details[0].unitPrice,
				}
			: product
		const products = JSON.parse(JSON.stringify(state.products))
		const key = article.voucherId + ";" + article.price
		if (products[key] && products[key].cnt === 1) {
			delete products[key]
		} else if (products[key]) {
			products[key].cnt--
		}

		return {
			order: {
				...state,
				products,
			},
		}
	})
}

export const addCollection = product => {
	appStore.set(rootState => {
		let state = rootState.order

		let shoppingCart = appStore.get("order.shoppingCart") || []

		tracking.addToCart(
			{
				...product,
				details: [
					{
						...product,
						unitPrice: product.details
							.map(e => e.amounts)
							.flat()
							.reduce((v, n) => {
								return v + n.grossAmount
							}, 0),
						amounts: product.details.map(e => e.amounts).flat(),
					},
				],
			},
			true,
		)
		//it seems to be a product from the localStorage of the location website because only then we have a product without an articleId
		if (window.self !== window.top) {
			//the article to remove dont exists

			let key = "collectionId"
			const articleId = product[key]
			//search inside the localStorage
			shoppingCart = JSON.parse(JSON.stringify(appStore.get("order.shoppingCart") || []))
			let entryIndex = shoppingCart.findIndex(e => e[key] == articleId)

			if (shoppingCart[entryIndex]) {
				shoppingCart[entryIndex].quantity++
			}
		} else {
			console.log("add unkown product")
			console.log(product)
		}

		return {
			order: {
				...state,
				shoppingCart,
			},
		}
	})
	calcPrice()
}

export const addProduct = product => {
	if (product.typeId == ORDER_LINE_TYPES.Collection) {
		return addCollection(product)
	}

	appStore.set(rootState => {
		let state = rootState.order

		const article = product
		const products = { ...state.products }
		let shoppingCart = appStore.get("order.shoppingCart") || []
		if (article.articleId) {
			const line = {
				article,
				cnt: products[article.articleId] ? products[article.articleId].cnt + 1 : 1,
			}
			products[article.articleId] = line

			tracking.addToCart(article)
		} else {
			tracking.addToCart(article, true)
			//it seems to be a product from the localStorage of the location website because only then we have a product without an articleId
			if (window.self !== window.top) {
				//the article to remove dont exists

				let key = "articleId"
				if (product.details[0].typeId === ORDER_LINE_TYPES.Voucher) {
					key = "voucherId"
				}

				const articleId = product.details[0][key]
				//search inside the localStorage
				shoppingCart = JSON.parse(JSON.stringify(appStore.get("order.shoppingCart") || []))
				let entryIndex = shoppingCart.findIndex(e => e[key] == articleId)

				if (shoppingCart[entryIndex]) {
					shoppingCart[entryIndex].quantity++
				}
			} else {
				console.log("add unkown product")
				console.log(product)
			}
		}

		return {
			order: {
				...state,
				shoppingCart,
				products,
			},
		}
	})
	calcPrice()
}

export const isLoungerAddable = lounger => {
	let rootState = appStore.getState()

	let state = rootState.order

	const loungers = [...state.loungers]
	//calc here the visitorKinds
	const pCount = selectVisitorCount(rootState)
	const nextLoungerCount = loungers.length + 1
	const currentUsedCapacity = selectUsedCapacity(rootState)

	const missingCapacity = selectMissingCapacity(rootState)
	const nextUsedCapacity = currentUsedCapacity + lounger.capacity
	//return true or error

	if ((nextUsedCapacity <= pCount || missingCapacity === 1) && nextLoungerCount <= pCount) {
		return true
	} else {
		return false
	}
}

export const addLounger = (lounger, ignoreChecks = false) => {
	let isValid = true

	appStore.set(rootState => {
		let state = rootState.order

		const loungers = [...state.loungers]
		const errors = [...state.errors]
		if (!ignoreChecks) {
			if (isLoungerAddable(lounger)) {
				loungers.push(lounger)
				isValid = true
			} else {
				isValid = false
				errors.push({
					id: uuidv4(),
					message: OrderErrors.noMoreCapacityThanGuests,
				})
			}

			if (isValid) {
				tracking.addLounger(lounger)
			}
		} else {
			loungers.push(lounger)
		}

		return {
			order: {
				...state,
				loungers: JSON.parse(JSON.stringify(loungers)),
				errors,
			},
		}
	})
	calcPrice()
	return isValid
}

export const removeLounger = lounger => {
	appStore.set(rootState => {
		let state = rootState.order

		let loungers = [...state.loungers]
		loungers.splice(
			loungers.findIndex(e => e.lounger_id === lounger.lounger_id),
			1,
		)
		tracking.removeLounger(lounger)
		return {
			order: {
				...state,
				loungers,
			},
		}
	})
	calcPrice()
}

export const addVisitorKind = (visitor, referenceCode) => {
	appStore.set(rootState => {
		let state = rootState.order
		const visitorKinds = { ...state.visitorKinds }

		let references = [...(visitorKinds[visitor.visitorKindId] ? visitorKinds[visitor.visitorKindId].references : [])]
		if (referenceCode) {
			references.push(referenceCode)
		}

		const line = {
			visitor,
			cnt: visitorKinds[visitor.visitorKindId] ? visitorKinds[visitor.visitorKindId].cnt + 1 : 1,
			references: references,
		}
		visitorKinds[visitor.visitorKindId] = line
		return {
			order: {
				...state,
				visitorKinds,
			},
		}
	})
	calcPrice()
}

export const removeVisitorKind = visitor => {
	appStore.set(rootState => {
		let state = rootState.order
		const visitorKinds = JSON.parse(JSON.stringify(state.visitorKinds))
		const priceActions = [...state.priceActions]

		let visitorRef = visitorKinds[visitor.visitorKindId].references[visitorKinds[visitor.visitorKindId].cnt - 1] || undefined

		if (visitorRef) {
			let index = priceActions.findIndex(e => e.priceActionCode === visitorRef)
			if (index >= -1) {
				priceActions.splice(index, 1)
			}
		}

		if (visitorKinds[visitor.visitorKindId] && visitorKinds[visitor.visitorKindId].cnt === 1) {
			delete visitorKinds[visitor.visitorKindId]
		} else if (visitorKinds[visitor.visitorKindId]) {
			visitorKinds[visitor.visitorKindId].cnt--
			let newCnt = visitorKinds[visitor.visitorKindId].cnt
			visitorKinds[visitor.visitorKindId].references.splice(newCnt, visitorKinds[visitor.visitorKindId].references.length)
		}
		return {
			order: {
				...state,
				visitorKinds,
				priceActions,
			},
		}
	})
	calcPrice()
}

/**
 * @param {{price: number, dateString: string, date: Date, restCount: number, exists: boolean, error, message: string }} day
 */
export const setSelectedDay = day => {
	appStore.set(rootState => {
		let state = rootState.order
		day.valid = day.restCount > 0 && day.exists !== false
		if (day.message) {
			day.valid = !day.message.startsWith("wrn.VisitorKind.NoAccess")
		}
		return {
			order: {
				...state,
				selectedDay: { ...day, date: day.dateString, dateObj: day.date },
				selectedTs: undefined,
				selectedTb: undefined,
				selectedTbKind: undefined,
				loungers: [],
			},
		}
	})
}

export const setSelectedTimeblockKind = tb => {
	appStore.set(rootState => {
		let state = rootState.order
		return {
			order: {
				...state,
				selectedTbKind: tb,
				selectedTbId: tb ? tb.timeBlocks[0].timeBlockTypeId : undefined,
				selectedTb: tb ? (tb.timeBlocks[0].timeBlockTypeId === TICKET_TYPES.WholeDay ? tb.timeBlocks[0] : undefined) : undefined,
				selectedTs: tb ? (tb.timeBlocks[0].timeBlockTypeId === TICKET_TYPES.WholeDay ? tb.timeBlocks[0].timeSlots[0] : undefined) : undefined,
			},
		}
	})
}

export const setSelectedTimeslot = (ts, tb) => {
	appStore.set(rootState => {
		let state = rootState.order
		return {
			order: {
				...state,
				selectedTb: tb,
				selectedTbId: tb.timeBlockTypeId,
				selectedTs: ts,
			},
		}
	})
}

/**
 * We need to provide the results of the loungerTypes, parkingTickets, baseProducts to use the translations
 */
export const setFormattedOrder = (formattedOrder, baseLoungerTypes, parkingTickets, baseProducts) => {
	if (!formattedOrder) {
		if (window.self !== window.top) {
			window.parent.postMessage(IframeMessages.setShoppingCart + ";" + JSON.stringify([]), "*")
		}

		appStore.set(rootState => {
			let state = rootState.order
			return {
				order: {
					...state,
					formattedOrder,
				},
			}
		})
		return
	}
	const articles = [...baseProducts]
	const loungerTypes = []

	Object.keys(baseLoungerTypes).forEach(key => {
		loungerTypes.push(...baseLoungerTypes[key])
	})

	formattedOrder.orderLines.forEach(orderLine => {
		orderLine.details.forEach(detail => {
			let typeId = detail.originalTypeId || detail.typeId

			if (typeId === ORDER_LINE_TYPES.Object || typeId === ORDER_LINE_TYPES.ObjectGroup) {
				let source = loungerTypes.find(e => e.objectGroupId === detail.objectGroupId)
				if (source && source.loungerType) detail.description = source.loungerType
			} else if (typeId === ORDER_LINE_TYPES.Article) {
				let source = articles.find(e => e.articleId == detail.articleId)
				if (source && source.title) detail.description = source.title
			} else if (typeId === ORDER_LINE_TYPES.Ticket) {
				let source = parkingTickets.find(e => e.ticketId == detail.ticketId)
				if (source && source.name) detail.description = source.name
			}
		})
	})

	let shoppingCart = [...formattedOrder.orderLines]
	shoppingCart.forEach((e, i, a) => {
		a[i] = {
			...e,
			...e.details[0],
			quantity: e.quantity || e.details[0].quantity,
		}
		if (a[i].typeId === ORDER_LINE_TYPES.Account) {
			a[i].amount = a[i].unitPrice
		}
		if (e.typeId == ORDER_LINE_TYPES.Collection) {
			a[i] = { ...e }
		}
	})
	shoppingCart = shoppingCart.filter(e => !e.feeId).filter(e => e.typeId !== ORDER_LINE_TYPES.VoucherDetail)

	shoppingCart = shoppingCart.filter(e => e.quantity >= 0)

	shoppingCart = shoppingCart.filter(e => {
		if (e.bookingLifeTimeEnd) {
			let x = new Date(e.bookingLifeTimeEnd)
			if (x.getTime() <= new Date().getTime()) {
				return false
			}
		}
		return true
	})

	if (window.self !== window.top) {
		window.parent.postMessage(IframeMessages.setShoppingCart + ";" + JSON.stringify(shoppingCart), "*")
	}

	appStore.set(rootState => {
		let state = rootState.order
		return {
			order: {
				...state,
				formattedOrder,
			},
		}
	})
}

export const setObjectGroupOptions = savedOptions => {
	appStore.set(rootState => {
		let state = rootState.order
		return {
			order: {
				...state,
				objectGroupOptions: savedOptions,
			},
		}
	})
}

/**
 *
 * @param {*} priceAction
 * @returns false if the actionCode is already used
 */
export const addPriceAction = action => {
	const priceActions = appStore.get("order.priceActions")

	let mapByKey = ""
	if (action.scanCodeTypeId === SCANCODE_TYPES.TICKET) {
		mapByKey = "scanCode"
	}
	if (action.scanCodeTypeId === SCANCODE_TYPES.VOUCHER) {
		mapByKey = "scanCode"
	}
	if (action.scanCodeTypeId === SCANCODE_TYPES.PRICEACTION) {
		mapByKey = "priceActionCode"
	}

	if (priceActions.find(e => (!e[mapByKey] ? false : e[mapByKey].toLowerCase() === action[mapByKey].toLowerCase()))) {
		return false
	}

	if (action.scanCodeTypeId === SCANCODE_TYPES.PRICEACTION) {
		tracking.addPromotionCode(action.priceActionCode)
	}

	appStore.set(rootState => {
		let state = rootState.order
		return {
			order: {
				...state,
				priceActions: [...state.priceActions, action],
			},
		}
	})
	return true
}

export const removePriceAction = action => {
	appStore.set(rootState => {
		let state = rootState.order

		const priceActions = JSON.parse(JSON.stringify(rootState.order.priceActions))

		let cnt = priceActions.length

		let mapByKey = ""
		if (action.scanCodeTypeId === SCANCODE_TYPES.TICKET) {
			mapByKey = "scanCode"
		}
		if (action.scanCodeTypeId === SCANCODE_TYPES.VOUCHER) {
			mapByKey = "scanCode"
		}
		if (action.scanCodeTypeId === SCANCODE_TYPES.PRICEACTION) {
			mapByKey = "priceActionCode"
		}

		while (cnt--) {
			let index = priceActions.findIndex(e => e[mapByKey] === action[mapByKey])
			if (index !== -1) {
				priceActions.splice(index, 1)
			}
		}

		return {
			order: {
				...state,
				priceActions: [...priceActions],
			},
		}
	})
}

export const setPayment = paymentGroup => {
	appStore.set(rootState => {
		let state = rootState.order
		return {
			order: {
				...state,
				payment: paymentGroup,
			},
		}
	})
}

export const addParkingTicket = parkingTicket => {
	tracking.addParkingTicket(parkingTicket)

	appStore.set(rootState => {
		let state = rootState.order
		const parkingTickets = { ...state.parkingTickets }
		const line = {
			parkingTicket,
			cnt: parkingTickets[parkingTicket.ticketId] ? parkingTickets[parkingTicket.ticketId].cnt + 1 : 1,
		}

		parkingTickets[parkingTicket.ticketId] = line

		// let shoppingCart = appStore.get("order.shoppingCart") || [];
		// if (window.self !== window.top) {//the article to remove dont exists

		//     let key = "ticketId";
		//     const articleId = parkingTicket[key]
		//     //search inside the localStorage
		//     shoppingCart = JSON.parse(JSON.stringify((appStore.get("order.shoppingCart") || [])))
		//     let entryIndex = shoppingCart.findIndex(e => e[key] == articleId)
		//     if (shoppingCart[entryIndex]) {
		//         shoppingCart[entryIndex].quantity++;
		//     }
		// }

		return {
			order: {
				...state,
				parkingTickets,
				// shoppingCart
			},
		}
	})
}
export const removeParkingTicket = parkingTicket => {
	tracking.removeParkingTicket(parkingTicket)

	appStore.set(rootState => {
		let state = rootState.order
		const parkingTickets = JSON.parse(JSON.stringify(state.parkingTickets))
		let shoppingCart = appStore.get("order.shoppingCart") || []
		if (parkingTickets[parkingTicket.ticketId] && parkingTickets[parkingTicket.ticketId].cnt === 1) {
			delete parkingTickets[parkingTicket.ticketId]
		} else if (parkingTickets[parkingTicket.ticketId]) {
			parkingTickets[parkingTicket.ticketId].cnt--
		} else {
			//the ticket to remove dont exists locally
			if (window.self !== window.top) {
				let key = "ticketId"
				const articleId = parkingTicket[key]
				//search inside the localStorage
				shoppingCart = JSON.parse(JSON.stringify(appStore.get("order.shoppingCart") || []))
				console.log(shoppingCart)
				let entryIndex = shoppingCart.findIndex(e => e[key] == articleId)

				if (shoppingCart[entryIndex]) {
					if (shoppingCart[entryIndex].quantity <= 1) {
						shoppingCart.splice(entryIndex, 1)
					} else {
						shoppingCart[entryIndex].quantity--
					}
				}
			}
		}

		return {
			order: {
				...state,
				parkingTickets,
				shoppingCart,
			},
		}
	})
}

/**
 * saves the form data of the addressdetails
 * @returns
 */
export const setAddresses = addressDetails => {
	appStore.set(rootState => {
		let state = rootState.core
		return {
			core: {
				...state,
				deliveryAddress: addressDetails.find(e => e && e.addressTypeId === ADRESS_TYPES.DELIVERY),
				invoiceAddress: addressDetails.find(e => e && e.addressTypeId === ADRESS_TYPES.INVOICE),
			},
		}
	})
}

export const useSetShoppingCart = () => {
	const [mapExternalCodes] = useMapExternalCodes()
	const raiseError = useRaiseError()

	return shoppingCart => {
		let nextCart = JSON.parse(JSON.stringify(shoppingCart))

		let items2Map = []
		for (let entry of shoppingCart) {
			if (entry.produkt_id) {
				//its a location product so we need to remap them
				const quantity = Number(entry.anzahl)
				const produkt_id = Number(entry.produkt_id)
				const posonas_type_id = Number(entry.posonas_type_id)
				const shipping_type = Number(entry.shipping_type) //
				const gutscheinvorlage_id = Number(entry.gutscheinvorlage_id) //currently ignored
				const adds = Object.keys(entry || {}).filter(e => e.startsWith("zubehoer"))

				items2Map.push({
					quantity,
					exportCode: produkt_id,
					typeId: posonas_type_id,
					shipping_type,
					gutscheinvorlage_id,
				})

				adds.forEach((add, i, a) => {
					a[i] = add.replace(/(^.*\[|\].*$)/g, "")
					items2Map.push({
						quantity: 1,
						exportCode: a[i],
					})
				})

				nextCart.splice(nextCart.indexOf(entry), 1)
			}
		}

		if (items2Map.length) {
			mapExternalCodes({ items: items2Map })
				.unwrap()
				.then(e => {
					for (let mapped of e) {
						nextCart.push({
							typeId: mapped.typeId,
							voucherId: mapped.voucherId,
							articleId: mapped.articleId,
							collectionId: mapped.collectionId,
							quantity: items2Map.find(e => e.exportCode == mapped.exportCode).quantity,
							transporterExportCode: items2Map.find(e => e.exportCode == mapped.exportCode).shipping_type,
						})
					}
					appStore.set(rootState => {
						let state = rootState.order
						return {
							order: {
								...state,
								shoppingCart: nextCart,
							},
						}
					})
				})
				.catch(e => {
					raiseError(e)
				})
		} else {
			appStore.set(rootState => {
				let state = rootState.order
				return {
					order: {
						...state,
						shoppingCart: nextCart,
					},
				}
			})
		}
	}
}

/**
 *
 * @returns true if a lounger was added
 */
export const selectLoungerId = (objectGroup, objectId, __types) => {
	let types = []

	Object.keys(__types).forEach(key => {
		types.push(...__types[key])
	})

	let isValid = true

	appStore.set(state => {
		let loungers = state.order.loungers
		loungers = JSON.parse(JSON.stringify(loungers))
		let nextLoungers = loungers

		let isAlreadySelected = loungers.find(e => e.selectedId === objectId)

		if (isAlreadySelected) {
			isAlreadySelected.selectedId = undefined
			isValid = false
		} else {
			let firstWithSameGroupAndNoSelection = loungers.find(e => e.objectGroupId === objectGroup.objectGroupId && !e.selectedId)
			if (firstWithSameGroupAndNoSelection) {
				const index = nextLoungers.indexOf(firstWithSameGroupAndNoSelection)
				firstWithSameGroupAndNoSelection.selectedId = objectId
				nextLoungers[index] = firstWithSameGroupAndNoSelection
			} else {
				let firstWithNoSelection = nextLoungers.find(e => !e.selectedId)

				if (firstWithNoSelection) {
					let index = nextLoungers.indexOf(firstWithNoSelection)
					firstWithNoSelection = {
						...types.find(e => e.objectGroupId === objectGroup.objectGroupId),
						price: objectGroup.price || types.find(e => e.objectGroupId === objectGroup.objectGroupId).price,
					}
					firstWithNoSelection.selectedId = objectId
					nextLoungers[index] = firstWithNoSelection
				} else {
					let next = JSON.parse(JSON.stringify(types.find(e => e.objectGroupId === objectGroup.objectGroupId)))
					next.price = objectGroup.price || next.price
					next.selectedId = objectId
					isValid = addLounger(next)
					nextLoungers = appStore.get("order.loungers")
				}
			}
		}

		nextLoungers = checkOverbooking(nextLoungers, state, appStore.get("core.onSiteMode"))

		return {
			order: {
				...appStore.get("order"),
				loungers: nextLoungers,
			},
		}
	})

	return isValid
}

const checkOverbooking = (loungers, state, onSite) => {
	let capacityOfSelectedLoungers = loungers
		.filter(e => e.selectedId !== undefined)
		.reduce((cap, n) => {
			return cap + n.capacity
		}, 0)
	//If we use the lounger tablets the needed capacity is always the sum of all lounger capacites
	let neededCapcity = onSite ? loungers.reduce((c, v) => c + v.capacity, 0) : selectNeededCapacity(state)
	let openCapacity = neededCapcity - capacityOfSelectedLoungers

	if (openCapacity <= 0) {
		//remove all other lounger without selection because capacity is filled
		loungers = loungers.filter(e => e.selectedId)
	} else if (openCapacity === 1) {
		//if only one capacity is left remove all loungers that are not selected execept the first one without selection
		let fWithoutSelection = true
		loungers = loungers.filter(e => {
			if (e.selectedId) return true

			if (fWithoutSelection) {
				fWithoutSelection = false
				return true
			}

			return false
		})
	}

	return loungers
}

export const useDeleteEntrance = () => {
	const [deleteReserverationForId] = useDeleteObjectOption()
	const objectGroupOptions = useSelector(state => state.order.objectGroupOptions)
	const raiseError = useRaiseError()
	const shoppingCart = useSelector(state => state.order.shoppingCart)
	const selectedDay = useSelector(state => state.order.selectedDay)
	const selectedZoneId = useSelector(state => state.core.zoneId)

	return (date, zoneId) => {
		date.setHours(12)
		let sDate = date.toISOString().slice(0, 10)
		let nextOrder = appStore.get(state => state.order)
		let nextCart = JSON.parse(JSON.stringify(shoppingCart))
		let cnt = nextCart.length

		while (cnt--) {
			let e = nextCart[cnt]
			if (
				e.typeId === ORDER_LINE_TYPES.Ticket ||
				e.typeId === ORDER_LINE_TYPES.Activity ||
				e.typeId === ORDER_LINE_TYPES.Object ||
				e.typeId === ORDER_LINE_TYPES.ObjectGroup
			) {
				let temp = nextCart[cnt]
				let deleted = false
				if (e.date === sDate && e.zoneId === zoneId) {
					nextCart.splice(cnt, 1)
					deleted = true
					// eslint-disable-next-line no-dupe-else-if
				} else if (e.zoneId === zoneId && e.date === sDate && (e.typeId === ORDER_LINE_TYPES.Object || e.typeId === ORDER_LINE_TYPES.ObjectGroup)) {
					nextCart.splice(cnt, 1)
					deleteReserverationForId({ objectOptionId: e.objectOptionId })
					deleted = true
				}

				if (deleted) {
					tracking.removeFromCart(temp, true)
				}
			}
		}

		let currentDate = selectedDay ? selectedDay.date : undefined
		if (currentDate && currentDate === sDate && zoneId === selectedZoneId) {
			//the deleted entry is the current object so we delete everything in the state
			Promise.all(
				objectGroupOptions.map(object => {
					return deleteReserverationForId({ objectOptionId: object.objectOptionId }).unwrap()
				}),
			).catch(e => {
				if (e instanceof ResponseError) {
					if (e && e.response.data && e.response.data.errorMessage && e.response.data.errorMessage.startsWith("wrn.Object.OptionNotFound")) {
						return
					}
				}
				raiseError(e, undefined, true)
			})
			nextOrder = {
				...nextOrder,
				loungers: [],
				objectGroupOptions: [],
				parkingTickets: {},
				massages: [],
				selectedDay: undefined,
				selectedTb: undefined,
				selectedTbId: undefined,
				selectedTbKind: undefined,
				selectedTs: undefined,
				visitorKinds: [],
			}
		}
		nextOrder = {
			...nextOrder,
			massages: nextOrder.massages.filter(e => {
				if (e.zoneId !== zoneId && e.date !== date.toISOString().slice(0, 10)) {
					return true
				} else {
					tracking.removeMassage(e)
				}
			}),
		}
		let loungers = appStore.get("order.loungers")
		for (let l of loungers) {
			tracking.removeLounger(l)
		}
		tracking.removeTickets()
		appStore.set(() => ({
			order: {
				...nextOrder,
				shoppingCart: nextCart,
			},
		}))
	}
}

/**
 * Apply the saved storage to the state,
 * override the priceActions of the state, but apply the stores orderlines to a different value storage.orderLines
 * so that we doesn't override any value of the current flow
 * @deprecated Not implemented so doesn't have a effect, the formatOrder can only handle one day
 */
export const applyStorage = () => {
	// let orderLines = JSON.parse(localStorage.getItem("orderLines"))
	// let priceActions = JSON.parse(localStorage.getItem("priceActions"))
	// appStore.set(state => ({
	//     storage : {
	//         orderLines
	//     },
	//     order: {
	//         ...state.order,
	//         priceActions: priceActions
	//     }
	// }))
}

export const addMassage = massage => {
	appStore.set(state => {
		let massages = [...state.order.massages]
		massages.push(massage)
		tracking.addMassage(massage)
		return {
			order: {
				...state.order,
				massages,
			},
		}
	})
}

export function deleteOrderLine(orderLine, quantity) {
	const fd = orderLine.details ? orderLine.details[0] : orderLine
	if (orderLine.typeId === ORDER_LINE_TYPES.Collection) {
		deleteCollectionLine(orderLine)
	} else if (fd.article_id) {
		//cms product
		deleteProductLine(fd)
	} else if (fd.typeId === ORDER_LINE_TYPES.Account) {
		deleteThermencardLine(orderLine, quantity)
	} else if (fd.typeId === ORDER_LINE_TYPES.Activity) {
		deleteMassageLine(orderLine)
	} else if (fd.typeId === ORDER_LINE_TYPES.Article) {
		deleteProductLine(orderLine)
	} else if (fd.typeId === ORDER_LINE_TYPES.Voucher) {
		deleteProductLine(orderLine)
	} else {
		console.error("cant delete the type: " + fd.typeId)
	}
}

export const deleteCollectionLine = orderLine => {
	appStore.set(rootState => {
		let state = rootState.order
		let shoppingCart = appStore.get("order.shoppingCart") || []

		if (window.self !== window.top) {
			//the article to remove dont exists
			tracking.removeFromCart(
				{
					...orderLine,
					quantity: 1,
					details: [
						{
							...orderLine,
							unitPrice: orderLine.details
								.map(e => e.amounts)
								.flat()
								.reduce((v, n) => {
									return v + n.grossAmount / orderLine.quantity
								}, 0),
							amounts: orderLine.details.map(e => e.amounts).flat(),
							quantity: 1,
						},
					],
				},
				true,
			)
			//search inside the localStorage
			let key = "collectionId"
			const articleId = orderLine.collectionId
			//search inside the localStorage
			shoppingCart = JSON.parse(JSON.stringify(appStore.get("order.shoppingCart") || []))
			let entryIndex = shoppingCart.findIndex(e => e[key] == articleId)

			if (shoppingCart[entryIndex]) {
				if (shoppingCart[entryIndex].quantity === 1) {
					shoppingCart.splice(entryIndex, 1)
				} else {
					shoppingCart[entryIndex].quantity--
				}
			}
		} else {
			console.log("deleteunkown collection")
			console.log(orderLine)
		}

		return {
			order: {
				...state,
				shoppingCart,
			},
		}
	})
}

export const deleteProductLine = product => {
	appStore.set(rootState => {
		let state = rootState.order

		const article = product
		const products = JSON.parse(JSON.stringify(state.products))
		let shoppingCart = appStore.get("order.shoppingCart") || []

		if (products[article.articleId] && products[article.articleId].cnt === 1) {
			delete products[article.articleId]
			tracking.removeFromCart(article)
		} else if (products[article.articleId]) {
			products[article.articleId].cnt--
			tracking.removeFromCart(article)
		} else if (window.self !== window.top) {
			//the article to remove dont exists
			tracking.removeFromCart(article, true)
			//search inside the localStorage
			if (window.self !== window.top) {
				//the article to remove dont exists

				let key = "articleId"
				if (product.details[0].typeId === ORDER_LINE_TYPES.Voucher) {
					key = "voucherId"
				}
				const articleId = product.details[0][key]
				//search inside the localStorage
				shoppingCart = JSON.parse(JSON.stringify(appStore.get("order.shoppingCart") || []))
				let entryIndex = shoppingCart.findIndex(e => e[key] == articleId)

				if (shoppingCart[entryIndex]) {
					if (shoppingCart[entryIndex].quantity === 1) {
						shoppingCart.splice(entryIndex, 1)
					} else {
						shoppingCart[entryIndex].quantity--
					}
				}
			} else {
				console.log("remove unkown product")
				console.log(product)
			}
		} else {
			console.log("deleteunkown product")
			console.log(product)
		}

		return {
			order: {
				...state,
				shoppingCart,
				products,
			},
		}
	})

	calcPrice()
}

export const deleteMassageLine = orderLine => {
	let fd = orderLine.details[0]

	const massages = appStore.get("order.massages")
	console.log(massages)
	if (massages) {
		let index = massages.findIndex(e => e.activityId === fd.activityId)
		console.log(index)
		if (index !== -1) {
			massages.splice(index, 1)
			appStore.set("order.massages", massages)
			tracking.removeMassage(fd)
			return
		}
	}

	const shoppingCart = appStore.get("order.shoppingCart")

	let entryIndex = shoppingCart
		? shoppingCart.findIndex(sce => {
				if (sce.typeId === ORDER_LINE_TYPES.Activity && sce.activityId === fd.activityId) {
					return true
				}
				return false
			})
		: undefined

	if (shoppingCart[entryIndex]) {
		if (shoppingCart[entryIndex].quantity === 1) {
			shoppingCart.splice(entryIndex, 1)
		} else {
			shoppingCart[entryIndex].quantity--
		}
	}
	tracking.removeMassage(fd)

	appStore.set("order.shoppingCart", shoppingCart)
}

export const deleteThermencardLine = orderLine => {
	let fd = orderLine.details[0]
	const sessionTopUps = appStore.get("order.thermencardRefillInfo")
	if (sessionTopUps) {
		let index = sessionTopUps.findIndex(e => e.accountToken === fd.accountToken && e.accountTemplateId === fd.accountTemplateId)
		if (index !== -1) {
			sessionTopUps.splice(index, 1)
			appStore.set("order.thermencardRefillInfo", sessionTopUps)
			tracking.removeThermencardRefill(orderLine)
			return
		}
	}

	const shoppingCart = appStore.get("order.shoppingCart")

	let entryIndex = shoppingCart
		? shoppingCart.findIndex(sce => {
				if (sce.typeId === ORDER_LINE_TYPES.Account && sce.accountToken === fd.accountToken && sce.accountTemplateId === fd.accountTemplateId) {
					return true
				}
				return false
			})
		: undefined

	if (shoppingCart[entryIndex]) {
		if (shoppingCart[entryIndex].quantity === 1) {
			shoppingCart.splice(entryIndex, 1)
		} else {
			shoppingCart[entryIndex].quantity--
		}
	}
	tracking.removeThermencardRefill(orderLine)

	appStore.set("order.shoppingCart", shoppingCart)
}

export const addThermencardLine = orderLine => {
	let fd = orderLine.details ? orderLine.details[0] : orderLine
	const current = appStore.get("order.thermencardRefillInfo")
	let item = {
		accountToken: fd.accountToken,
		accountTemplateId: Number(fd.accountTemplateId),
		amount: Number(fd.unitPrice || fd.amount),
		typeId: ORDER_LINE_TYPES.Account,
		accountTemplate: fd.description || fd.accountTemplate,
	}
	current.push(item)
	tracking.addThermencardRefill(item)
	appStore.set("order.thermencardRefillInfo", current)
}
